import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";

const Hamburger = ({ state }) => {
  let menu = useRef(null);
  let revealMenu = useRef(null);
  let revealMenuBackground = useRef(null);

  let line1 = useRef(null);
  let line2 = useRef(null);
  let line3 = useRef(null);
  let info = useRef(null);

  useEffect(() => {
    // If the menu is open and we click the menu button to close it.
    if (state.clicked === false) {
      // If menu is closed and we want to open it.
      gsap.to([revealMenu, revealMenuBackground], {
        duration: 0.8,
        height: 0,
        ease: "power3.inOut",
        stagger: {
          amount: 0.07,
        },
      });

      gsap.to(menu, { duration: 1, css: { display: "none" } });
    } else if (
      state.clicked === true ||
      (state.clicked === true && state.initial === null)
    ) {
      // Set menu to display block
      gsap.to(menu, { duration: 0, css: { display: "block" } });
      //Allow menu to have height of 100%
      gsap.to([revealMenuBackground, revealMenu], {
        duration: 0.8,
        height: "100%",
        ease: "power3.inOut",
        stagger: {
          amount: 0.07,
        },
      });
      // gsap.to([revealMenuBackground], {
      //   duration: 0.0,
      //   opacity: 1,
      //   height: "100%"
      // });
      // gsap.to([revealMenu], {
      //   duration: 0,
      //   opacity: 1,
      //   height: "100%"
      // });
      if (state.clicked === true && state.initial === null) {
        staggerReveal(revealMenuBackground, revealMenu);
      }
      fadeInUp(info);
      staggerText(line1, line2, line3);
    }
  }, [state]);

  const staggerReveal = (node1, node2) => {
    gsap.from([node1, node2], {
      duration: 0.8,
      height: "0",
      transformOrigin: "right top",
      skewY: 2,
      ease: "power3.inOut",
      stagger: {
        amount: 0.1,
      },
    });
  };

  const staggerText = (node1, node2, node3) => {
    gsap.from([node1, node2, node3], {
      duration: 0.8,
      y: 60,
      delay: 0.1,

      skewY: 2,
      ease: "power3.inOut",
      stagger: {
        amount: 0.3,
      },
    });
  };

  const fadeInUp = (node) => {
    gsap.from(node, {
      y: 60,
      duration: 1,
      delay: 0.2,
      opacity: 0,
      ease: "power3.inOut",
    });
  };

  return (
    <div ref={(el) => (menu = el)} className="hamburger-menu">
      <div
        ref={(el) => (revealMenuBackground = el)}
        className="menu-secondary-background-color"
      >
        <div ref={(el) => (revealMenu = el)} className="menu-layer">
          <div className="menu-city-background"></div>
          <div className="container">
            <div className="wrapper">
              <div className="menu-links">
                <nav>
                  <ul>
                    <li>
                      <Link ref={(el) => (line1 = el)} to="/projects">
                        Projects
                      </Link>
                    </li>
                    <li>
                      <Link ref={(el) => (line2 = el)} to="/blogs">
                        Blog Dump
                      </Link>
                    </li>
                    <li>
                      <Link ref={(el) => (line3 = el)} to="/resume">
                        Resume
                      </Link>
                    </li>
                  </ul>
                </nav>
                <div ref={(el) => (info = el)} className="info">
                  <h5>Web Dev, UI/UX & Marketing</h5>
                  <p>
                    Reactjs portfolio using Routers<br></br> and GSAP for UI.<br></br> Find this design on my Github profile!
                  </p>
                </div>
                <div className="locations">
                  Find me here:
                  <span>
                    <a href="mailto:aishani.pachauri@gmail.com">Email</a>
                  </span>
                  <span><a href="https://www.linkedin.com/in/aishanipachauri/" target="_blank">Linkedin</a></span>
                  <span><a href="https://github.com/Aishanipach" target="_blank">Github</a></span>
                  <span><a href="https://aishani-pachauri.medium.com/" target="_blank">Medium</a></span>
                  <span><a href="https://dev.to/aishanipach" target="_blank">Dev</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hamburger;
